import React, { useState } from "react";

import { Form, Button } from "react-bootstrap";

const UploadFileInput = ({
    className,
    label,
    buttonText,
    multiple,
    accept = "*",
    selectedFiles = [],
    onchange,
    // onFilesSelected
}) => {
    const handleButtonClick = () => {
        document.getElementById("hiddenFileInput").click();
    };

    return (
        <>
            <Form.Group className={`${className}`}>
                <div className="d-flex align-items-center">
                    <Form.Label htmlFor="hiddenFileInput">{label}</Form.Label>
                    <Button
                        variant="primary"
                        onClick={handleButtonClick}
                        className="hidden-file-input-btn"
                    >
                        {selectedFiles?.length > 0
                            ? `${selectedFiles?.length} file(s) selected`
                            : buttonText}
                    </Button>
                    <Form.Control
                        id="hiddenFileInput"
                        type="file"
                        multiple={multiple}
                        accept={accept}
                        onChange={onchange}
                        style={{ display: "none" }}
                    />
                </div>
            </Form.Group>

            {selectedFiles.length > 0 && (
                <div>
                    {selectedFiles.map((file, index) => (
                        <p key={index}>{file.name}</p>
                    ))}
                </div>
            )}
        </>
    );
};

export default UploadFileInput;
